<template>
  <ScratchcardInfoModal
    v-slot="{ close }"
    :headline="$t('scratchcard.order.infobutton.details.headline')"
    :tracking="{ topicKey: 'scratchcard-revealed-details-modal' }"
  >
    <section class="flex flex-col gap-300">
      <ul class="flex flex-col gap-300">
        <ScratchcardListItem
          class="bg-secondary-secondary rounded-m p-100"
          :label="$t('scratchcard.order.infobutton.details.label.serialnumber')"
        >
          {{ serialNumber }}
        </ScratchcardListItem>

        <li class="bg-secondary-secondary rounded-m p-100 flex flex-col gap-100 text-capitalize">
          <ScratchcardListItem :label="$t('scratchcard.order.infobutton.details.label.orderedat')">
            {{ formatDate(orderedDate, 'drawing', undefined, locale) }}
          </ScratchcardListItem>

          <ScratchcardListItem
            :label="$t('scratchcard.order.infobutton.details.label.processedat')"
          >
            {{ formatDate(processedDate, 'drawing', undefined, locale) }}
          </ScratchcardListItem>
        </li>
      </ul>

      <div class="flex items-center gap-100 mt-300">
        <LcIcon class="bg-secondary-secondary p-100 rounded-m" name="email" />
        <div class="flex flex-col">
          <span class="caption-bold">
            {{ $t('scratchcard.order.infobutton.details.label.questions') }}
          </span>
          <HyperLink
            class="link-caption-regular text-accent-accent-hyperlink"
            :to="$localePath('/service?chat=true')"
          >
            {{ $t('scratchcard.order.infobutton.details.label.contact') }}
          </HyperLink>
        </div>
      </div>
    </section>

    <LcButton variant="secondary" @click="close">
      {{ $t('scratchcard.order.infobutton.details.button.close') }}
    </LcButton>
  </ScratchcardInfoModal>
</template>

<script lang="ts" setup>
type ScratchcardButtonInfoDetailsProps = {
  orderedDate: string
  processedDate: string
  serialNumber: string
}

defineProps<ScratchcardButtonInfoDetailsProps>()

const { locale } = useI18n()
</script>
